<template>
  <div class="tab-item">
    <div class="item" v-for="item in dataList" :key="item.id">
      <div class="novel-container" v-if="item.type===2 || item.type === 8" @click="showDetailItem(item)">
        <div class="novel-cover">
          <img v-lazy="item.cover_url"/>
          <div v-if="item.isDel" class="mask-img"></div>
        </div>
        <div class="novel-info">
          <div class="novel-title-box">
            <div class="novel-title"> <div class="left">{{item.title}}<span class="tag-comic" v-if="item.type === 8"> <Tag type="danger" plain class="comic-tag">漫画</Tag> </span> </div>
              <div class="right" @click.stop="onClickMore(item)">
                <icon-svg icon-class="more" style="color: rgba(180,180,180,0.67)"></icon-svg>
              </div>
            </div>
            <div class="rate-container" @click.stop="toComment(item)" v-if="item.rate_desc">
              <div class="rate-main">
                <div class="rate-value" v-if="item.rate_value">{{item.rate_value.toFixed(1)}}</div>
                <Rate readonly size="14" color="#ffd21e" v-model="item.rate_value"></Rate>
              </div>
              <div class="rate-desc">
                {{item.rate_desc}}
              </div>
            </div>
            <div class="novel-actions">
              <div class="comment-actions" @click.stop="toComment(item)">
                <icon-svg icon-class="feedback" style="font-size: 16px;"></icon-svg>
                <div class="comment-count" v-if="item.comment_count_desc">{{item.comment_count_desc}}</div>
              </div>
              <div class="book-shelf-actions">
                <BookShelfAction :item="item"></BookShelfAction>
              </div>
            </div>
          </div>
          <div class="continue-container">
            <div class="continue-desc">上次阅读到第 {{item.last_read_page}} 章</div>
            <Button size="small" plain round hairline color="#ffbb31">继续阅读</Button>
          </div>
          <div>
          </div>
        </div>
      </div>
    </div>
    <ActionSheet v-model="showActions" :actions="actions" :round="false" cancel-text="取消" close-on-click-action
                 @select="onSelect" style="z-index:10000"></ActionSheet>
  </div>
</template>

<script>

  import {ugcItemTypeMovie, ugcItemTypeSeries, ugcItemTypeComic, ugcItemTypeComicWt} from "../../util/const";
  import {Tag, Rate, Button, ActionSheet} from "vant"
  import BookShelfAction from "../common/BookShelfAction";

  export default {
    name: "MixItemListLite",
    components: {
      BookShelfAction, Tag, Rate, Button, ActionSheet,
    },
    props: {
      dataList: {
        type: Array,
        default: () => []
      },
      showFavorite: {
        type: Boolean,
        default: false,
      }
    },

    data() {
      return {
        actions: [{"name": "删除"}],
        showActions: false,
        actionItem: null,
      }
    },
    mounted() {
    },
    methods: {
      showDetailItem(item) {
        if (item.type === 2) {
          this.$router.push('/novel/' + item.id);
        } else if (item.type === 0) {
          this.$router.push('/video/' + item.id);
        } else if (item.type === ugcItemTypeMovie || item.type === ugcItemTypeSeries) {
          this.$router.push("/movie/" + item.id)
        } else if (item.type === ugcItemTypeComic || item.type === ugcItemTypeComicWt) {
          this.$router.push("/comic/" + item.id)
        }
      },
      toRate(item) {
        this.$router.push("/rate/item/" + item.id)
      },

      toComment(item) {
        this.$router.push("/comment/" + item.id)
      },
      onClickMore(item) {
        this.showActions = true
        this.actionItem = item
      },

      onSelect(item) {
        this.showActions = false
        if(item.name === "删除") {
          this.onClickDel()
        }
      },

      onClickDel() {
        this.actionItem.isDel = true
        this.actionItem.title = "已删除"
        this.$emit("onDelete", this.actionItem.id)
      }
    },
    computed: {}
  };
</script>

<style lang="scss" scoped>
  .tab-item {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .item {
      width: 100%;

      .novel-container {
        display: flex;
        background: white;
        padding: 12px 4px;
        overflow: hidden;
        border-bottom: 1px solid #e8e8e8;
      }
    }

    .novel-cover {
      position: relative;
      width: 80px;
      height: 100px;
      margin-left: 12px;
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      .mask-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        font-size: 16px;
        background: rgba(0, 0, 0, 0.47);
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
      }


      img {
        height: 100px;
      }
    }

    .rate-container {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      line-height: 1.5;
      margin-top: 8px;

      .rate-main {
        display: flex;
        align-items: center;
        margin-right: 12px;

        .rate-value {
          font-size: 20px;
          font-weight: bold;
          margin-right: 8px;
        }
      }

      .rate-desc {
        font-size: 12px;
      }
    }

    .continue-container {
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .continue-desc {
      }
    }


    .novel-info {
      flex: 1 1 auto;
      padding: 5px 28px;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: grey;

      .novel-title-box {

        .novel-actions {
          margin-top: 8px;
          display: flex;

          .comment-actions {
            font-size: 14px;
            display: flex;
            align-items: center;
            min-width: 18px;

            .comment-count {
              margin-left: 5px;
              font-size: 14px;
            }
          }

          .book-shelf-actions {
            margin-left: 21px;
          }
        }
      }

      .novel-title {
        font-size: 14px;
        font-weight: bold;
        line-height: 1.5;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          display: flex;
          align-items: center;

          .tag-comic {
            margin-left: 5px;
            flex: 0 0 auto;
          }
        }

        .right {
          flex: 0 0 auto;
          padding: 0 5px;
        }

      }

      .novel-description {
        margin-top: 12px;
        color: rgba(0, 0, 0, 0.75);
        font-size: 12px;
        line-height: 1.5;
        max-height: 90px;
        display: -webkit-box;
        -webkit-line-clamp: 3; /*显示3行，超出的用省略号代替*/
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .novel-options {
        display: flex;
        align-items: center;

        .tags {
          font-size: 12px;
          flex: 1 1 auto;
          width: 70%;
        }

        .tag-item {
          margin-right: 8px;
          margin-bottom: 5px;
        }

        .option {
        }
      }
    }
  }
</style>
